import React, { useState, useEffect } from "react"
import axios from "axios"
import { ChevronDown, ChevronUp } from "lucide-react"
import { unserialize } from "php-serialize"
import { BaseUrl } from "../App"
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const SettingsTable = () => {
  const [settings, setSettings] = useState({})
  const [isEnabled, setIsEnabled] = useState({})
  const [isRequired, setIsRequired] = useState({})
   const [loading, setLoading] = useState(false);

  const [minLengths, setMinLengths] = useState({})
  const [maxLengths, setMaxLengths] = useState({})
  const [languages, setLanguages] = useState([])
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [frontErrorLabels, setFrontErrorLabels] = useState(() => {
    const initialLabels = {}
    languages.forEach((lang) => {
      initialLabels[lang.language] = {}
    })
    return initialLabels
  })
  const [openLanguage, setOpenLanguage] = useState(null)
  const [decodedLanguages, setDecodedLanguages] = useState([])

  const labelMapping = {
    min_ff_ps: "Minimum characters message for Password",
    max_ff_ps: "Maximum characters message for Password",
    req_ff_fn: "Required message for First Name",
    min_ff_fn: "Minimum characters message for First Name",
    max_ff_fn: "Maximum characters message for First Name",
    req_ff_ln: "Required message for Last Name",
    min_ff_ln: "Minimum characters message for Last Name",
    max_ff_ln: "Maximum characters message for Last Name",
    req_ff_ph: "Required message for Phone",
    min_ff_ph: "Minimum characters message for Phone",
    max_ff_ph: "Maximum characters message for Phone",
    req_ff_sa: "Required message for Street Address",
    min_ff_sa: "Minimum characters message for Street Address",
    max_ff_sa: "Maximum characters message for Street Address",
    req_ff_zp: "Required message for Zip Code",
    min_ff_zp: "Minimum characters message for Zip Code",
    max_ff_zp: "Maximum characters message for Zip Code",
    req_ff_ct: "Required message for City",
    min_ff_ct: "Minimum characters message for City",
    max_ff_ct: "Maximum characters message for City",
    req_ff_st: "Required message for State",
    min_ff_st: "Minimum characters message for State",
    max_ff_st: "Maximum characters message for State",
    req_ff_srn: "Required message for Notes",
    min_ff_srn: "Minimum characters message for Notes",
    max_ff_srn: "Maximum characters message for Notes",
    Transaction_failed_please_try_again: "Transaction failed message",
    Please_Enter_valid_card_detail: "Invalid card details message",
  }

  const splitValueFields = [
    "ct_bf_password",
    "ct_bf_first_name",
    "ct_bf_last_name",
    "ct_bf_phone",
    "ct_bf_address",
    "ct_bf_zip_code",
    "ct_bf_city",
    "ct_bf_state",
    "ct_bf_notes",
  ]

  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  useEffect(() => {
    fetchSettings()
    fetchLanguages()
  }, [])


  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: "get_all_settings",
        api_key: "1",
      })

      if (response.data.status === "true" && Array.isArray(response.data.response)) {
        const newSettings = {}
        const enabledState = {}
        const requiredState = {}
        const minLengthsState = {}
        const maxLengthsState = {}

        response.data.response.forEach((setting) => {
          const { option_name, option_value } = setting

          if (splitValueFields.includes(option_name)) {
            const [enabled, required, minLength, maxLength] = option_value.split(",")
            enabledState[option_name] = enabled === "Y" || enabled === "on"
            requiredState[option_name] = required === "Y"
            minLengthsState[option_name] = Number.parseInt(minLength, 10) || 0
            maxLengthsState[option_name] = Number.parseInt(maxLength, 10) || 0
          } else {
            enabledState[option_name] = option_value === "Y" || option_value === "on"
          }

          newSettings[option_name] = option_value
        })

        enabledState["ct_bf_email"] = true
        enabledState["ct_bf_password"] = true
        requiredState["ct_bf_email"] = true
        requiredState["ct_bf_password"] = true

        minLengthsState["ct_bf_password"] = Number.parseInt(newSettings["ct_bf_password"].split(",")[2], 10) || 0
        maxLengthsState["ct_bf_password"] = Number.parseInt(newSettings["ct_bf_password"].split(",")[3], 10) || 0

        setSettings(newSettings)
        setIsEnabled(enabledState)
        setIsRequired(requiredState)
        setMinLengths(minLengthsState)
        setMaxLengths(maxLengthsState)
      }
    } catch (error) {
      console.error("Error fetching settings:", error)
    }   finally {
      setLoading(false);
    }
  }

  const fetchLanguages = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/language_labels.php`,
        { action: "get_all_languages", api_key: "1" },
        { headers: { "Content-Type": "application/json" } }
      )

      const rawData = response.data.data
      console.log("Raw language data:", rawData)

      const processedData = rawData.map((language) => {
        let decodedLabelData = {}
        if (language.front_error_labels) {
          try {
            const decodedString = atob(language.front_error_labels)
            const unserialized = unserialize(decodedString)
            decodedLabelData = Object.entries(unserialized).reduce((acc, [key, value]) => {
              acc[labelMapping[key] || key] = value
              return acc
            }, {})
          } catch (error) {
            console.error(`Error decoding/unserializing label data for ${language.language}:`, error)
          }   finally {
      setLoading(false);
    }
        }

        return {
          ...language,
          front_error_labels: decodedLabelData,
        }
      })

      console.log("Processed language data:", processedData)
      setDecodedLanguages(processedData)
      setLanguages(processedData)

      const initialFrontErrorLabels = {}
      processedData.forEach((lang) => {
        initialFrontErrorLabels[lang.language] = lang.front_error_labels
      })
      setFrontErrorLabels((prevLabels) => ({
        ...prevLabels,
        ...initialFrontErrorLabels,
      }))
    } catch (error) {
      console.error("Error fetching languages:", error)
    }
  }

  const handleSave = async () => {
    try {
      // Save settings first
      await handleSaveSettings();
      
      // Then save language settings
      for (const language of languages) {
        await handleSaveLanguageSettings(language);
      }
      console.log("All settings updated successfully!");
    } catch (error) {
      console.error("Error saving settings:", error);
    }
  };

  const handleSaveSettings = async () => {
    setLoading(true);
    try {
      const updatedSettings = {};
      
      // Process each setting
      settingsList.forEach((setting) => {
        const { field } = setting;
        
        if (splitValueFields.includes(field)) {
          // Format split value fields
          const enabled = isEnabled[field] ? "Y" : "N";
          const required = isRequired[field] ? "Y" : "N";
          const minLength = minLengths[field] || 0;
          const maxLength = maxLengths[field] || 0;
          updatedSettings[field] = `${enabled},${required},${minLength},${maxLength}`;
        } else {
          // Format regular fields
          updatedSettings[field] = isEnabled[field] ? "Y" : "N";
        }
      });

      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: "update_settings",
        api_key: "1",
        settings: updatedSettings
      });

      if (response.data.status === "true") {
        setSuccessMessage(" Update Setting Successfully!")
        console.log("Settings updated successfully!");
      } else {
        console.error("Failed to update settings:", response.data.response);
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      throw error;
    }    finally {
      setLoading(false);
    }
  };

  const handleSaveLanguageSettings = async (language) => {
    setLoading(true);
    try {
      const payload = {
        action: "update_language_labels",
        api_key: "1",
        id: language.id,
        language_front_arr: JSON.stringify({}),
        language_admin_arr: JSON.stringify({}),
        language_error_arr: JSON.stringify({}),
        language_extra_arr: JSON.stringify({}),
        language_front_error_arr: JSON.stringify(frontErrorLabels[language.language] || {})
      };

      const response = await axios.post(
        `${BaseUrl}/backend/api/language_labels.php`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage(`Settings for ${language.language} updated successfully!`);
        console.log(`Settings for ${language.language} updated successfully!`);
      } else {
        console.error(`Failed to update settings for ${language.language}:`, response.data.response);
      }
    } catch (error) {
      console.error(`Error updating settings for ${language.language}:`, error);
      throw error;
    }   finally {
      setLoading(false);
    }
  };

  const toggleLanguage = (language) => {
    setOpenLanguage(openLanguage === language ? null : language)
  }

  const handleLabelChange = (language, key, value) => {
    setFrontErrorLabels((prev) => ({
      ...prev,
      [language]: {
        ...prev[language],
        [key]: value,
      },
    }))
  }

  const settingsList = [
    { name: "Show Company Logo", field: "ct_company_logo_display" },
    { name: "Show Company Title", field: "ct_company_title_display" },
    { name: "Show Company Address in Header", field: "ct_company_header_address" },
    { name: "Front language flag list", field: "ct_front_language_selection_dropdown" },
    { name: "Show description", field: "ct_company_service_desc_status" },
    { name: "Sub Headings on Booking Page", field: "ct_subheaders" },
    { name: "Wallet Section", field: "ct_wallet_section" },
    { name: "Appointment Details Section", field: "ct_appointment_details_display" },
    { name: "Preferred Email", field: "ct_bf_email" },
    { name: "Preferred Password", field: "ct_bf_password" },
    { name: "First Name", field: "ct_bf_first_name" },
    { name: "Last Name", field: "ct_bf_last_name" },
    { name: "Phone", field: "ct_bf_phone" },
    { name: "Street Address", field: "ct_bf_address" },
    { name: "Zip code", field: "ct_bf_zip_code" },
    { name: "City", field: "ct_bf_city" },
    { name: "State", field: "ct_bf_state" },
    { name: "Special Request (Notes)", field: "ct_bf_notes" },
    { name: "Vaccume Cleaner", field: "ct_vc_status" },
    { name: "Parking", field: "ct_p_status" },
    { name: "Show How wil we get in", field: "ct_company_willwe_getin_status" },
    { name: "Show Coupons input on checkout", field: "ct_show_coupons_input_on_checkout" },
    { name: "Show Referral Code", field: "ct_referral_status" },
  ]


  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
           {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
        <h2 className="text-lg font-semibold text-gray-700">Manageable Form Fields For Front Booking Form</h2>
        <button
          onClick={handleSave}
          className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
        >
          Save Setting
        </button>
      </div>

      <div className="overflow-x-auto -mx-4 sm:mx-0">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden shadow-sm ring-1 ring-black ring-opacity-5 rounded-lg">
            {/* Desktop view */}
            <table className="hidden sm:table min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Field Name</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Enable/Disable</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Required</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Min Length</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Max Length</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {settingsList.map((setting) => (
                  <tr key={setting.field}>
                    <td className="px-4 py-3 text-sm text-gray-900">{setting.name}</td>
                    <td className="px-4 py-3 text-sm">
                      {setting.field === "ct_bf_email" || setting.field === "ct_bf_password" ? (
                        <span className="text-green-500">Enabled</span>
                      ) : (
                        <div className="flex items-center">
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={isEnabled[setting.field]}
                              onChange={() => setIsEnabled({ ...isEnabled, [setting.field]: !isEnabled[setting.field] })}
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                          </label>
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {setting.field === "ct_bf_email" || setting.field === "ct_bf_password" ? (
                        <span className="text-green-500">Required</span>
                      ) : (
                        splitValueFields.includes(setting.field) && (
                          <div className="flex items-center">
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={isRequired[setting.field]}
                                onChange={() => setIsRequired({ ...isRequired, [setting.field]: !isRequired[setting.field] })}
                              />
                              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                            </label>
                          </div>
                        )
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {splitValueFields.includes(setting.field) && setting.field !== "ct_bf_email" && (
                        <div className="flex items-center space-x-2">
                          <NumberInput
                            value={minLengths[setting.field] || 0}
                            onChange={(value) => setMinLengths({ ...minLengths, [setting.field]: value })}
                          />
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {splitValueFields.includes(setting.field) && setting.field !== "ct_bf_email" && (
                        <div className="flex items-center space-x-2">
                          <NumberInput
                            value={maxLengths[setting.field] || 0}
                            onChange={(value) => setMaxLengths({ ...maxLengths, [setting.field]: value })}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Mobile view */}
            <div className="sm:hidden divide-y divide-gray-200">
              {settingsList.map((setting) => (
                <div key={setting.field} className="p-4 space-y-4 bg-white">
                  <div className="font-medium text-gray-900">{setting.name}</div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm text-gray-500">Enable/Disable</label>
                      <div className="mt-1">
                        {setting.field === "ct_bf_email" || setting.field === "ct_bf_password" ? (
                          <span className="text-green-500">Enabled</span>
                        ) : (
                          <div className="flex items-center">
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={isEnabled[setting.field]}
                                onChange={() => setIsEnabled({ ...isEnabled, [setting.field]: !isEnabled[setting.field] })}
                              />
                              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                            </label>
                          </div>
                        )}
                      </div>
                    </div>

                    {splitValueFields.includes(setting.field) && (
                      <div>
                        <label className="text-sm text-gray-500">Required</label>
                        <div className="mt-1">
                          {setting.field === "ct_bf_email" || setting.field === "ct_bf_password" ? (
                            <span className="text-green-500">Required</span>
                          ) : (
                            <div className="flex items-center">
                              <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  className="sr-only peer"
                                  checked={isRequired[setting.field]}
                                  onChange={() => setIsRequired({ ...isRequired, [setting.field]: !isRequired[setting.field] })}
                                />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {splitValueFields.includes(setting.field) && setting.field !== "ct_bf_email" && (
                      <>
                        <div>
                          <label className="text-sm text-gray-500">Min Length</label>
                          <div className="mt-1">
                            <NumberInput
                              value={minLengths[setting.field] || 0}
                              onChange={(value) => setMinLengths({ ...minLengths, [setting.field]: value })}
                            />
                          </div>
                        </div>
                        <div>
                          <label className="text-sm text-gray-500">Max Length</label>
                          <div className="mt-1">
                            <NumberInput
                              value={maxLengths[setting.field] || 0}
                              onChange={(value) => setMaxLengths({ ...maxLengths, [setting.field]: value })}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={handleSave}
        className="w-full sm:w-auto px-4 py-2 mt-6 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
      >
        Save Setting
      </button>

      {/* Language Settings Section */}
      <div className="mt-8 bg-white rounded-lg shadow-md">
        <h2 className="text-lg font-semibold text-gray-700 p-4">Language-specific Error Messages</h2>
        <div className="divide-y divide-gray-200">
          {languages.map((lang) => (
            <div key={lang.language} className="overflow-hidden">
              <div
                className="flex justify-between items-center px-4 py-3 bg-gray-50 hover:bg-gray-100 cursor-pointer"
                onClick={() => toggleLanguage(lang.language)}
              >
                <span className="text-base sm:text-lg font-semibold text-gray-700">{lang.language}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    toggleLanguage(lang.language)
                  }}
                  className="p-2 hover:bg-gray-200 rounded-full transition-colors"
                >
                  {openLanguage === lang.language ? (
                    <ChevronUp className="w-5 h-5 text-gray-600" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-600" />
                  )}
                </button>
              </div>
              
              {openLanguage === lang.language && (
                <div className="p-4 space-y-4 bg-white">
                  {Object.entries(frontErrorLabels[lang.language] || {}).map(([key, value]) => (
                    <div key={key} className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">{key}</label>
                      <input
                        type="text"
                        value={value || ""}
                        onChange={(e) => handleLabelChange(lang.language, key, e.target.value)}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  ))}
                  {Object.keys(frontErrorLabels[lang.language] || {}).length === 0 && (
                    <p className="text-gray-500 italic">No front error labels found for this language.</p>
                  )}
                  <button
                    onClick={() => handleSaveLanguageSettings(lang)}
                    className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
                  >
                    Save {lang.language} Settings
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    
  </div>
  )
}

const NumberInput = ({ value, onChange }) => (
  <div className="flex items-center rounded-md border border-gray-300 overflow-hidden">
    <button
      type="button"
      onClick={() => onChange(Math.max(0, value - 1))}
      className="px-2 py-1 bg-gray-100 text-gray-600 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
    >
      -
    </button>
    <input
      type="number"
      value={value}
      onChange={(e) => onChange(Math.max(0, parseInt(e.target.value, 10) || 0))}
      className="w-12 text-center border-x border-gray-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
    />
    <button
      type="button"
      onClick={() => onChange(value + 1)}
      className="px-2 py-1 bg-gray-100 text-gray-600 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
    >
      +
    </button>
  </div>
)
export default SettingsTable


// const SettingsTable = () => {
//   const [minLengths, setMinLengths] = useState({
//     preferredEmail: 0,
//     preferredPassword: 0,
//     firstName: 0,
//     lastName: 0,
//     phone: 0,
//     streetAddress: 0,
//     zipCode: 0,
//     city: 0,
//     state: 0,
//     specialRequests: 0,
//   });

//   const [maxLengths, setMaxLengths] = useState({
//     preferredEmail: 0,
//     preferredPassword: 0,
//     firstName: 0,
//     lastName: 0,
//     phone: 0,
//     streetAddress: 0,
//     zipCode: 0,
//     city: 0,
//     state: 0,
//     specialRequests: 0,
//   });

//   const [isEnabled, setIsEnabled] = useState({
//     preferredEmail: false,
//     preferredPassword: false,
//     firstName: true,
//     lastName: true,
//     phone: true,
//     streetAddress: true,
//     zipCode: true,
//     city: true,
//     state: true,
//     specialRequests: false,
//     vacuumCleaner: false,
//     parking: false,
//     referralCode: false,
//     showHowWillWeGetIn: false,
//     showCouponsInput: false,
//   });

//   // State for "Required" toggle
//   const [isRequired, setIsRequired] = useState({
//     preferredEmail: false,
//     preferredPassword: false,
//     firstName: false,
//     lastName: false,
//     phone: false,
//     streetAddress: false,
//     zipCode: false,
//     city: false,
//     state: false,
//     specialRequests: false,
//     vacuumCleaner: false,
//     parking: false,
//     referralCode: false,
//     showHowWillWeGetIn: false,
//     showCouponsInput: false,
//   });

//   const handleMinLengthChange = (field, action) => {
//     setMinLengths((prev) => {
//       const updatedMinLengths = { ...prev };
//       if (action === "increment") updatedMinLengths[field] += 1;
//       else if (action === "decrement" && updatedMinLengths[field] > 0)
//         updatedMinLengths[field] -= 1;
//       return updatedMinLengths;
//     });
//   };

//   const handleMaxLengthChange = (field, action) => {
//     setMaxLengths((prev) => {
//       const updatedMaxLengths = { ...prev };
//       if (action === "increment") updatedMaxLengths[field] += 1;
//       else if (action === "decrement" && updatedMaxLengths[field] > 0)
//         updatedMaxLengths[field] -= 1;
//       return updatedMaxLengths;
//     });
//   };

//   const toggleEnable = (field) => {
//     setIsEnabled((prev) => {
//       const updatedIsEnabled = { ...prev };
//       updatedIsEnabled[field] = !updatedIsEnabled[field];
//       return updatedIsEnabled;
//     });
//   };

//   // Toggle "Required" field
//   const toggleRequired = (field) => {
//     setIsRequired((prev) => {
//       const updatedIsRequired = { ...prev };
//       updatedIsRequired[field] = !updatedIsRequired[field];
//       return updatedIsRequired;
//     });
//   };

//   const settings = [
//     { name: "Show company logo", field: "showCompanyLogo" },
//     { name: "Show Company Title", field: "showCompanyTitle" },
//     { name: "Show company address in header", field: "showCompanyAddress" },
//     { name: "Front languages flag list", field: "frontLanguagesFlag" },
//     { name: "Show Description", field: "showDescription" },
//     { name: "Sub Headings on Booking page", field: "subHeadingsBooking" },
//     { name: "Wallet Section", field: "walletSection" },
//     { name: "Appointment Details Section", field: "appointmentDetails" },
//     { name: "Preferred Email", field: "preferredEmail" },
//     { name: "Preferred Password", field: "preferredPassword" },
//     { name: "First Name", field: "firstName" },
//     { name: "Last Name", field: "lastName" },
//     { name: "Phone", field: "phone" },
//     { name: "Street Address", field: "streetAddress" },
//     { name: "Zip Code", field: "zipCode" },
//     { name: "City", field: "city" },
//     { name: "State", field: "state" },
//     { name: "Special requests (Notes)", field: "specialRequests" },
//     { name: "Vacuum Cleaner", field: "vacuumCleaner" },
//     { name: "Parking", field: "parking" },
//     { name: "Show How will we get in", field: "showHowWillWeGetIn" },
//     { name: "Show coupons input on checkout", field: "showCouponsInput" },
//     { name: "Show Referral Code", field: "referralCode" },
//   ];

//   const handleSave = () => {
//     // Implement save logic, such as sending data to the backend or displaying a success message
//     console.log("Settings saved successfully!");
//   };

//   const [openLanguage, setOpenLanguage] = useState(null);

//   const toggleLanguage = (language) => {
//     setOpenLanguage(openLanguage === language ? null : language);
//   };

//   const languages = [
//     { name: "English (United States)" },
//     { name: "Deutsch" },
//     { name: "Español" },
//     { name: "Français" },
//     { name: "Português" },
//     { name: "Русский" },
//     { name: "العربية" },
//     { name: "简体中文" },
//   ];

//   const fields = [
//     {
//       label: "Minimum characters message for Password",
//       placeholder: "Please enter minimum 8 characters",
//     },
//     {
//       label: "Maximum characters message for Password",
//       placeholder: "Please enter maximum 10 characters",
//     },
//     {
//       label: "Required message for First Name",
//       placeholder: "Please enter first name",
//     },
//     {
//       label: "Minimum characters message for First Name",
//       placeholder: "Please enter minimum 3 characters",
//     },
//     {
//       label: "Maximum characters message for First Name",
//       placeholder: "Please enter maximum 15 characters",
//     },
//     {
//       label: "Required message for Last Name",
//       placeholder: "Please enter last name",
//     },
//     {
//       label: "Minimum characters message for Last Name",
//       placeholder: "Please enter minimum 3 characters",
//     },
//     {
//       label: "Maximum characters message for Last Name",
//       placeholder: "Please enter maximum 15 characters",
//     },
//     {
//       label: "Required message for Phone",
//       placeholder: "Please enter phone number",
//     },
//     {
//       label: "Minimum characters message for Phone",
//       placeholder: "Please enter minimum 9 characters",
//     },
//     {
//       label: "Maximum characters message for Phone",
//       placeholder: "Please enter maximum 15 characters",
//     },
//     {
//       label: "Required message for Street Address",
//       placeholder: "Please enter street address",
//     },
//     {
//       label: "Minimum characters message for Street Address",
//       placeholder: "Please enter minimum 10 characters",
//     },
//     {
//       label: "Maximum characters message for Street Address",
//       placeholder: "Please enter maximum 40 characters",
//     },
//     {
//       label: "Required message for Zip Code",
//       placeholder: "Please enter zip code",
//     },
//     {
//       label: "Minimum characters message for Zip Code",
//       placeholder: "Please enter minimum 3 characters",
//     },
//     {
//       label: "Maximum characters message for Zip Code",
//       placeholder: "Please enter maximum 7 characters",
//     },
//     { label: "Required message for City", placeholder: "Please enter city" },
//     {
//       label: "Minimum characters message for City",
//       placeholder: "Please enter minimum 3 characters",
//     },
//     {
//       label: "Maximum characters message for City",
//       placeholder: "Please enter maximum 15 characters",
//     },
//     { label: "Required message for State", placeholder: "Please enter state" },
//     {
//       label: "Minimum characters message for State",
//       placeholder: "Please enter minimum 3 characters",
//     },
//     {
//       label: "Maximum characters message for State",
//       placeholder: "Please enter maximum 15 characters",
//     },
//     { label: "Required message for Notes", placeholder: "Please enter notes" },
//     {
//       label: "Minimum characters message for Notes",
//       placeholder: "Please enter minimum 10 characters",
//     },
//     {
//       label: "Maximum characters message for Notes",
//       placeholder: "Please enter maximum 70 characters",
//     },
//     {
//       label: "Transaction failed please try again",
//       placeholder: "Transaction failed please try again",
//     },
//     {
//       label: "Please Enter valid card detail",
//       placeholder: "Please enter valid card detail",
//     },
//   ];

//   return (
//     <div className="overflow-x-auto xl:px-72">
//       <div className="flex justify-between items-center mb-4 ">
//         <h2 className="text-lg font-semibold text-gray-700">
//           Manageable Form Fields For Front Booking Form
//         </h2>
//         <button
//           onClick={() => handleSave()}
//           className="px-4 py-2 mt-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
//         >
//           Save Setting
//         </button>
//       </div>
//       <table className="min-w-full table-auto">
//         <thead>
//           <tr className="bg-gray-100 border-b">
//             <th className="px-4 py-2 text-left text-sm text-gray-600">
//               Field Name
//             </th>
//             <th className="px-4 py-2 text-left text-sm text-gray-600">
//               Enable/Disable
//             </th>
//             <th className="px-4 py-2 text-left text-sm text-gray-600">
//               Required
//             </th>
//             <th className="px-4 py-2 text-left text-sm text-gray-600">
//               Min Length
//             </th>
//             <th className="px-4 py-2 text-left text-sm text-gray-600">
//               Max Length
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {settings.map((setting) => (
//             <tr key={setting.field} className="border-b">
//               <td className="px-4 py-2 text-sm">{setting.name}</td>
//               <td className="px-4 py-2 text-sm">
//                 <label className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
//                   <input
//                     type="checkbox"
//                     className="absolute inset-0 opacity-0 peer"
//                     checked={isEnabled[setting.field]}
//                     onChange={() => toggleEnable(setting.field)}
//                   />
//                   <span className="block w-11 h-6 bg-gray-200 peer-checked:bg-green-500 rounded-full transition duration-200"></span>
//                   <span className="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow-md peer-checked:left-6 transition-all duration-200"></span>
//                 </label>
//               </td>
//               <td className="px-4 py-2 text-sm">
//                 <label className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative">
//                   <input
//                     type="checkbox"
//                     className="absolute inset-0 opacity-0 peer"
//                     checked={isRequired[setting.field]}
//                     onChange={() => toggleRequired(setting.field)}
//                   />
//                   <span className="block w-11 h-6 bg-gray-200 peer-checked:bg-green-500 rounded-full transition duration-200"></span>
//                   <span className="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow-md peer-checked:left-6 transition-all duration-200"></span>
//                 </label>
//                 <span className="ml-2">
//                   {isRequired[setting.field] }
//                 </span>
//               </td>
//               <td className="px-4 py-2 text-sm">
//                 <div className="flex items-center">
//                   <button
//                     onClick={() =>
//                       handleMinLengthChange(setting.field, "decrement")
//                     }
//                     className="px-2 py-1 bg-gray-200 rounded-l-md"
//                     disabled={minLengths[setting.field] <= 0}
//                   >
//                     -
//                   </button>
//                   <input
//                     type="number"
//                     value={minLengths[setting.field]}
//                     className="w-16 text-center border border-gray-300"
//                     onChange={(e) => {
//                       const value = Math.max(0, e.target.value);
//                       setMinLengths((prev) => ({
//                         ...prev,
//                         [setting.field]: value,
//                       }));
//                     }}
//                   />
//                   <button
//                     onClick={() =>
//                       handleMinLengthChange(setting.field, "increment")
//                     }
//                     className="px-2 py-1 bg-gray-200 rounded-r-md"
//                   >
//                     +
//                   </button>
//                 </div>
//               </td>
//               <td className="px-4 py-2 text-sm">
//                 <div className="flex items-center">
//                   <button
//                     onClick={() =>
//                       handleMaxLengthChange(setting.field, "decrement")
//                     }
//                     className="px-2 py-1 bg-gray-200 rounded-l-md"
//                     disabled={maxLengths[setting.field] <= 0}
//                   >
//                     -
//                   </button>
//                   <input
//                     type="number"
//                     value={maxLengths[setting.field]}
//                     className="w-16 text-center border border-gray-300"
//                     onChange={(e) => {
//                       const value = Math.max(0, e.target.value);
//                       setMaxLengths((prev) => ({
//                         ...prev,
//                         [setting.field]: value,
//                       }));
//                     }}
//                   />
//                   <button
//                     onClick={() =>
//                       handleMaxLengthChange(setting.field, "increment")
//                     }
//                     className="px-2 py-1 bg-gray-200 rounded-r-md"
//                   >
//                     +
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <div className="w-full bg-white rounded-lg shadow-md">
//         {languages.map((language, index) => (
//           <div
//             key={index}
//             className="border-b last:border-none overflow-hidden"
//           >
//             {/* Dropdown Button */}
//             <div className="flex justify-between items-center px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-t-md transition duration-300">
//               <button
//                 className="flex-1 text-left text-lg font-semibold text-gray-700 focus:outline-none hover:text-blue-500 transition duration-300"
//                 onClick={() => toggleLanguage(language.name)}
//               >
//                 {language.name}
//               </button>
//               {/* Toggle Button */}
//               <label className="relative inline-block w-11 h-6">
//                 <input
//                   type="checkbox"
//                   className="peer sr-only"
//                   checked={openLanguage === language.name}
//                   onChange={() => toggleLanguage(language.name)}
//                 />
//                 <div className="w-full h-full bg-gray-200 rounded-full peer-checked:bg-green-500 transition duration-300"></div>
//                 <div className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all duration-300 peer-checked:translate-x-5"></div>
//               </label>
//             </div>

//             {/* Dropdown Content */}
//             <div
//               className={`overflow-hidden transition-all duration-700 ease-in-out ${
//                 openLanguage === language.name
//                   ? "max-h-screen opacity-100"
//                   : "max-h-0 opacity-0"
//               }`}
//             >
//               <div className="p-4 space-y-4 bg-white rounded-b-md shadow-inner overflow-y-auto max-h-80">
//                 {fields.map((field, idx) => (
//                   <div key={idx} className="flex flex-col space-y-2">
//                     <label className="text-sm font-medium text-gray-700">
//                       {field.label}
//                     </label>
//                     <input
//                       type="text"
//                       placeholder={field.placeholder}
//                       className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                 ))}
//                 {/* Save Button */}
//                 <button className=" px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
//                   Save Settings
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SettingsTable;
